import React, { useContext } from 'react';
import { motion, useMotionValue } from 'framer-motion';
import Bg1 from '../../Assets/About/Circle.svg';
import Bg2 from '../../Assets/About/Question.svg';
import Persona from '../../Assets/About/Character.svg';
import { Button } from '@mui/material';
import { DefaultContext } from '../../Contexts/DefaultContext';
import { ptbr, eng } from '../../Translate';
import './local.css';
import '../../index.css';

function About() {
    const { LNG } = useContext(DefaultContext)
    const tiltStrength = 30; // ajuste isso conforme necessário

    const rotateX = useMotionValue(0);
    const rotateY = useMotionValue(0);

    const handleMouseMove = (e) => {
        const xPos = (e.clientX / window.innerWidth - 0.2) * tiltStrength;
        const yPos = (e.clientY / window.innerHeight - 0.2) * tiltStrength;
        rotateX.set(yPos);
        rotateY.set(-xPos);
    };

    return (
        <div
            id='about-container'
            onMouseMove={handleMouseMove}
        >
            <div className='about-section-container'>
                <div className='about-letters'>
                    <h1 className='titleTxt about-name'>{LNG ? ptbr.about.item_1 : eng.about.item_1}</h1>
                    <span className='bodyTxt about-body'>
                        {LNG ? ptbr.about.item_2 : eng.about.item_2}
                    </span>
                    <div className='about-media'>
                        <Button
                            className='about-act-button'
                            variant='contained'
                            onClick={() => window.open('https://www.linkedin.com/in/guilhermedora/', '_blank')}
                        >
                            {LNG ? ptbr.about.item_3 : eng.about.item_3}
                        </Button>
                    </div>
                </div>
                <div className='about-art-container'>
                    <img
                        className='about-elipse'
                        src={Bg1}
                        alt="Imagem"
                    />
                    <img
                        className='about-persona'
                        src={Persona}
                        alt="Imagem"
                    />
                    <motion.div
                        className='about-motion-background-2'
                        style={{
                            rotateX: rotateX,
                            rotateY: rotateY,
                        }}
                    >
                        <img
                            className='about-background-2'
                            src={Bg2}
                            alt="Imagem"
                        />
                    </motion.div>
                </div>
            </div>
        </div >
    );
}

export default About;